import actionConstants from "constants/actions";
import { updateDocumentTitle } from "util/titleManager";

const initialState = {
    storylineDetails: {},
    storylineInstanceDetails: {}
};

const storyline = (state = initialState, action = {}) => {
    switch (action.type) {
        case actionConstants.SET_INIT_DATA:
            const newState = {
                ...state,
                storylineDetails: action.payload.storylineDetails,
				storylineInstanceDetails: action.payload.storylineInstanceDetails,
				storylineDefaults: action.payload.storylineDefaults
            };
            
            // Update document title when storyline data is loaded
            updateDocumentTitle(newState.storylineDetails, newState.storylineInstanceDetails);
            
            return newState;
        default:
            return state;
    }
};

export default storyline;
